// src/components/OurWork.js
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from '../App.module.css';

const OurWork = () => {
  const [work, setWork] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const fetchEvents = async() => {
    try {
      const response = await fetch(`${baseurl}get-all-event.php`);
      const result = await response.json();
      setWork(result.data); // Adjust based on your API response 
      setLoading(false)        
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false)
    } finally {}
  };
  useEffect(()=>{
    fetchEvents()
  },[])
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows:false,
  };
  return (
    <>
      {
      loading ? (
        <div className="animate-pulse bg-slate-500 w-full">
          <div className="w-full bg-slate-500 py-5">
            <h2 className="text-5xl font-bold text-center uppercase text-white mb-5">Our Work</h2>
            <div className="grid grid-cols-3 gap-4 mb-3 px-3">
              <div className="flex items-center justify-center w-full h-44 bg-gray-300 rounded dark:bg-gray-700">
                <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                  <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                </svg>
              </div>
              <div className="flex items-center justify-center w-full h-44 bg-gray-300 rounded dark:bg-gray-700">
                <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                  <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                </svg>
              </div>
              <div className="flex items-center justify-center w-full h-44 bg-gray-300 rounded dark:bg-gray-700">
                <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                  <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                </svg>
              </div>              
            </div>
          </div>
        </div>
      ):(
        <section id="our-work" className="py-10 bg-dark" data-aos="flip-left"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="2000">
          <div className="container-fluid mx-auto text-center">
            <div className="row">
              <div className="col-md-12">            
                <h2 className="text-5xl font-bold uppercase text-white mb-5">Our Work</h2>
              </div>
              <div className="col-md-12">
                <Slider {...settings}>
                    {/* <div className={`${styles.our_work_small_img} mb-1`}>                  
                      <img loading="lazy" src='./images/work_small_1.png' alt="Our Work" />
                      </div> */}
                    {
                      work.map((workItem) =>
                        <div className="text-center px-3">
                          <div key={workItem.title} className={styles.our_work_large_img}>                  
                            <img loading="lazy" src={workItem.image} alt="Our Work" />
                          </div>
                        </div>            
                      )
                    }
                </Slider>
              </div>
              
            </div>
          </div>
        </section>
      )
    }
  </>
  );
}

export default OurWork;
